import { bootstrapApplication } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavbarComponent } from './app/navbar/navbar.component';
import { appConfig } from './app.config';
import { captureMaintenanceBypass } from './app/services/maintenance.guard';
import "@angular/compiler"

@Component({
  standalone: true,
  selector: 'app-root',
  template: `    
  <app-navbar></app-navbar>
  <div class="container mat-typography">
    <router-outlet></router-outlet>
  </div>
  `,
  imports: [CommonModule, RouterOutlet, NavbarComponent]
})
export class AppComponent {
  title = 'registerator';
}

// if (environment.production) {
//   enableProdMode();
// }

// Before the router: the root redirect would otherwise decide whether ?preview survives.
captureMaintenanceBypass();

bootstrapApplication(AppComponent, appConfig)
.catch(err => console.error(err));
